export default __webpack_public_path__ + "static/media/151-trees.c12c662b.png";